import { type MarketplacePaginatedRes as PaginatedRes } from '@dvb/common';
import { authAxios } from '@school-manage/api/client';

import type { News } from './news.types';

export const getNewsRequest = async (cursor?: string) => {
  const { data } = await authAxios.get<PaginatedRes<News[]>>(
    '/api/v1/notice/list',
    {
      params: { cursor },
    }
  );
  return data;
};

export const getNewsDetailRequest = async (newsId: string) => {
  const { data } = await authAxios.post<News>('/api/v1/notice/details', {
    uuid: newsId,
  });
  return data;
};
